// Search parameter keys for transaction pages
export const vendorsPageConstants = Object.freeze({
  SELECTED_VENDOR_ID: 'selectedVendorId',
});